/**
 * Key figure -- Design System v1.0, KPI card: Moka label, Bold 24 px value,
 * a line underneath. Green and orange are reserved for trends.
 */

import type { ReactNode } from 'react';

import { Icon, type IconName } from './Icon.js';

interface StatTileProps {
  label: string;
  value: ReactNode;
  icon?: IconName;
  meta?: ReactNode;
  tone?: 'default' | 'alert';
}

export function StatTile({ label, value, icon, meta, tone = 'default' }: StatTileProps) {
  return (
    <div className="kpi-card">
      <div className="row row--between">
        <p className="kpi-label">{label}</p>
        {icon && <Icon name={icon} size={18} className="text-muted" />}
      </div>
      <p className="kpi-value" style={tone === 'alert' ? { color: 'var(--color-danger)' } : undefined}>
        {value}
      </p>
      {meta && <p className="kpi-meta">{meta}</p>}
    </div>
  );
}
